var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConveniencia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38759 1H14.3806C16.2494 1 17.7682 2.50884 17.7682 4.3655V28.7835H1V4.3655C1 2.50884 2.51874 1 4.38759 1Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.541 4.19742H5.22638C4.65202 4.19742 4.1864 4.65994 4.1864 5.23055V9.42471C4.1864 9.99532 4.65202 10.4579 5.22638 10.4579H13.541C14.1153 10.4579 14.581 9.99532 14.581 9.42471V5.23055C14.581 4.65994 14.1153 4.19742 13.541 4.19742Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 28.7832H17.7682",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9327 16.9211C17.9327 16.9211 20.198 18.0771 20.2134 21.9387C20.2289 26.2659 23.6577 26.0255 23.6577 26.0255C23.6577 26.0255 27.9051 26.2045 27.9051 22.3377C27.9051 20.8902 27.4674 19.7496 26.9629 18.9057C26.4326 18.0259 25.645 17.3355 24.7491 16.8291C23.7864 16.2869 22.0977 14.9724 22.0977 12.4304",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1517 9.23463L23.076 7.73597C23.4569 7.54161 23.91 7.81268 23.91 8.24233V11.4953C23.91 11.8073 23.6526 12.0631 23.3385 12.0631H20.4142C20.1002 12.0631 19.8428 11.8073 19.8428 11.4953V9.7461C19.8428 9.53128 19.9612 9.33693 20.1517 9.23975V9.23463Z",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9092 8.2365C23.9092 8.2365 24.1718 4.19587 20.6915 2.59494",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConveniencia);
export default __webpack_public_path__ + "static/media/conveniencia.693fd2ae48952c6015564d97a552f928.svg";
export { ForwardRef as ReactComponent };